import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from 'services/token/token.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SIGN_IN_TYPES } from 'pages/entry/entry.helpers';
import { SmartForm } from '@certemy/ui-components';

@UntilDestroy()
@Component({
  selector: 'cm-self-enrollment-first-login',
  styleUrls: ['./self-enrollment-first-login.component.scss'],
  templateUrl: './self-enrollment-first-login.component.html',
})
export class SelfEnrollmentFirstLoginComponent implements OnInit, OnDestroy {
  token: string;
  selfEnrollmentTitle: string;
  enableToRegister;
  organizationRoles: SmartForm.FieldOption[];
  constructor(private route: ActivatedRoute, private router: Router, private tokenService: TokenService) {}

  ngOnInit() {
    this.tokenService
      .getLoginType()
      .pipe(untilDestroyed(this))
      .subscribe((result) => {
        if (result === SIGN_IN_TYPES.MEMBERCLICKS) {
          this.redirectToLogin();
        }
      });

    this.token = this.route.snapshot.params['token'];
    this.selfEnrollmentTitle = this.route.snapshot.params['title'];
    const { enabled, organizationRoles } = this.route.snapshot.data.registerData;
    this.enableToRegister = enabled;
    this.organizationRoles = organizationRoles;
  }

  ngOnDestroy() {}

  redirectToLogin() {
    this.router.navigateByUrl(`/entry/self-enrollments/${this.selfEnrollmentTitle}/${this.token}/login`);
  }
}
